export default __webpack_public_path__ + "static/media/panda-pert.a42858c1.png";